module.exports = __webpack_public_path__ + "img/bear-blue.71737ed3.svg";